import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import { API_DOMAIN } from './globals'; // Import the global domain name

function MyLedger() {

    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");

    const [declared, setDeclared] = useState({
        Summary: null,
        MatchBets: null,
        FancyBets: null,
    });
    const { gt, mn, id, dt } = useParams();

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    useEffect(() => {

        setUserType(sessionStorage.getItem("UserType"));
        setUserName(sessionStorage.getItem("UserName"));

        //console.log("UserType="+sessionStorage.getItem("UserType")+", userType="+userType);

        const url = `${API_DOMAIN}/api/Client/getDeclaredMatchDetails.php?id=${id}&ut=${sessionStorage.getItem("UserType")}&un=${sessionStorage.getItem("UserName")}&gt=${gt}&dt=${dt}&mn=${mn}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    setDeclared({
                        Summary: data.data[0].Summary,
                        MatchBets: data.data[1].Match_Bets,
                        FancyBets: data.data[2].Fancy_Bets,
                    });

                    console.log(declared.Summary);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="accountste match-content">
                <div className="table_tittle">
                    MATCH BETS
                    <div className="pull-right">
                        <Link to="/Dashboard/MyLedger">
                            <button className="btn btn-xs btn-primary pull-right">Back</button>
                        </Link>
                    </div>
                </div>
                <div className="appendAjaxTbl">
                    <div className="table-responsive sports-tabel">
                        {!declared.MatchBets || declared.MatchBets.length > 0 && (
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr className="headings" style={{ background: '#000',color:'white'}}>
                                        <th>TEAM</th>
                                        <th>Won By</th>
                                        <th>DATE</th>
                                        <th>RATE</th>
                                        <th>AMOUNT</th>
                                        <th>MODE</th>
                                        <th>P&amp;L</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {declared.MatchBets.map((row, index) => (
                                        <tr key={index} style={{ textTransform: 'capitalize' }}>
                                            <td style={{ textAlign: 'left', color:'black' }}>{row.Team.toLowerCase()}</td>
                                            <td style={{ textAlign: 'left', color:'black' }}>{row.WonBy}</td>
                                            <td style={{ textAlign: 'left', color:'black' }}>{row.BetTime}</td>
                                            <td style={{color:'black'}}>{row.Rate}</td>
                                            <td style={{color:'black'}}>{row.Amount}</td>
                                            <td style={{color:'black'}}>{row.Mode === 'K' ? 'LAGAAI' : 'KHAI'}</td>
                                            <td style={{color:'black'}}>
                                                <span
                                                    className={row.CMatchPM >= 0 ? 'green' : 'red'}
                                                >
                                                    {row.CMatchPM}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {!declared.FancyBets || declared.FancyBets.length > 0 && (
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr className="headings" style={{ background: '#000',color:'white'}}>
                                        <th>RUNNER</th>
                                        <th>DATE</th>
                                        <th>RUN</th>
                                        <th>RESULT</th>
                                        <th>AMOUNT</th>
                                        <th>MODE</th>
                                        <th>P&amp;L</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {declared.FancyBets.map((row, index) => (
                                        <tr key={index} style={{ textTransform: 'capitalize' }}>
                                            <td style={{ textAlign: 'left', color:'black' }}>{row.Fancy}</td>
                                            <td style={{ textAlign: 'left', color:'black' }}>{row.BetTime}</td>
                                            <td style={{color:'black'}}>{row.Run}</td>
                                            <td style={{color:'black'}}>{row.DR}</td>
                                            <td style={{color:'black'}}>{row.Amount}</td>
                                            <td style={{color:'black'}}>{row.Mode}</td>
                                            <td style={{color:'black'}}>
                                                <span
                                                    className={row.PM >= 0 ? 'green' : 'red'}
                                                >
                                                    {row.PM}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {!declared.Summary || declared.Summary.length > 0 && (
                        <div className="table-responsive sports-tabel">
                            <div>
                                <div className="ledger-header">Match Plus Minus</div>
                                <div
                                    className={`ledger-body ${declared.Summary[0].CMatchAmt >= 0 ? 'green' : 'red'}`}
                                >
                                    {declared.Summary[0].CMatchAmt >= 0
                                        ? `You Won ${declared.Summary[0].CMatchAmt}/- Coins.`
                                        : `You Lost ${declared.Summary[0].CMatchAmt}/- Coins.`}
                                </div>
                            </div>
                    
                            <div>
                                <div className="ledger-header">Fancy Plus Minus</div>
                                <div
                                    className={`ledger-body ${declared.Summary[0].CSessionAmt >= 0 ? 'green' : 'red'}`}
                                >
                                    {declared.Summary[0].CSessionAmt >= 0
                                        ? `You Won ${declared.Summary[0].CSessionAmt}/- Coins.`
                                        : `You Lost ${declared.Summary[0].CSessionAmt}/- Coins.`}
                                </div>
                            </div>

                            
                            <div>
                                <div className="ledger-header">Total Commission</div>
                                <div className="green ledger-body">
                                    {`You Won ${declared.Summary[0].CMSCommAmt}/- Coins.`}
                                </div>
                            </div>

                            
                            <div>
                                <div className="ledger-header">Mob. App. Charges</div>
                                <div className="red ledger-body">
                                    {`You Lost ${declared.Summary[0].CMobApp}/- Coins.`}
                                </div>
                            </div>

                            
                            <div>
                                <div className="ledger-header">Net Plus Minus</div>
                                <div
                                    className={`ledger-body ${declared.Summary[0].CFinalTotal >= 0 ? 'green' : 'red'}`}
                                >
                                    {declared.Summary[0].CFinalTotal >= 0
                                        ? `You Won ${declared.Summary[0].CFinalTotal}/- Coins.`
                                        : `You Lost ${declared.Summary[0].CFinalTotal}/- Coins.`}
                                </div>
                            </div>
                        
                        </div>
                    )}
                
                </div>
            </section>
            <section className="match-content">
                <div className="table_tittle">REJECTED BETS </div>
                <div className="table-responsive sports-tabel"></div>
            </section>

        </>
    )
}

export default MyLedger;
